export const srvSubdomainValidator = (value) => {
    if (!value) return "validate.srv_subdomain_required";

    if (value === "@") return "validate.srv_subdomain_not_root";

    // SRV записи должны начинаться с _
    const regex = /^_[a-zA-Z0-9-]+\._[a-zA-Z0-9-]+(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return regex.test(value) ? true : "validate.srv_subdomain_format";
}; 